import { mapActions, mapGetters } from 'vuex'
import pageHeader from '../../pageheader.vue'
import swal from 'sweetalert2'
import _ from 'lodash'

export default {
  name: 'setting',

  components: {
    pageHeader
  },

  data() {
    return {
      // 現在選択しているカテゴリID
      selectedCategoryId: '',
      // Vue画面表示用のselect-model、各category_option共通
      selectedCategoryOptions: [],
      // 現在のパスワード
      password: '',
      // 新しいパスワード
      newPassword: '',
      // 確認用パスワード
      confirmPassword: ''
    }
  },

  computed: {
    ...mapGetters('category', ['category']),
    ...mapGetters('setting', ['categoryOption']),
    ...mapGetters('auth', ['errMsg']),

    /**
     * カテゴリ一覧
     * 一応カテゴリIDの昇順に並び替え
     */
    categorys() {
      return _.orderBy(
        this.getCategorys_(),
        category => category.order,
        'asc'
      )
    },

    /**
     * カテゴリ設定リスト
     */
    categoryOptionList() {
      return this.categoryOption
    },

    /**
     * カテゴリ「全て」を選択した場合は、注意書きを表示
     */
    categoryAlertMessage() {
      const message = '全てのカテゴリの設定が更新されます'
      return this.selectedCategoryId === '00' ? message : ''
    }
  },

  methods: {
    ...mapActions('auth', ['logout', 'changePassword']),
    ...mapActions('category', ['getCategory']),

    ...mapActions('setting', [
      'getCategoryOptions',
      'updateCategorySetting'
    ]),

    /**
     * カテゴリ一覧を取得
     */
    getCategorys_() {
      const list = []
      _.forEach(this.category, cate => {
        list.push({
          id: cate.category_id,
          name: cate.category_name,
          order: cate.sort_order
        })
      })
      return list
    },

    /**
     * カテゴリ選択時、設定更新
     */
    selectCategory(categoryId) {
      this.selectedCategoryId = categoryId
      this.setCategoryOption_()
    },

    // 動的css。カテゴリ一覧選択行
    selectRow(categoryId) {
      return this.selectedCategoryId === categoryId ? 'category-setting-list__row--selected' : ''
    },

    /**
     * カテゴリ設定を選択したカテゴリのものに変更
     */
    setCategoryOption_() {
      const category = this.category[this.selectedCategoryId]
      _.forEach(this.categoryOptionList, (ol, i) => {
        this.selectedCategoryOptions[i] = category[ol.key]
      })
    },

    /**
     * カテゴリ設定更新ボタン押下
     * 更新確認を行う
     */
    categoryConfirm() {
      const categoryName = this.category[this.selectedCategoryId].category_name
      if (window.confirm(`カテゴリ「${categoryName}」について設定を保存しますか?`)) {
        this.saveCategory_()
      }
    },

    /**
     * カテゴリ設定を保存
     */
    async saveCategory_() {
      const options = {}
      _.forEach(this.categoryOptionList, (ol, i) => {
        options[this.categoryOptionList[i].key] = this.selectedCategoryOptions[i]
      })

      await this.updateCategorySetting({
        datas: { [this.selectedCategoryId]: options }
      })

      this.getCategory()
    },

    /**
     * ログアウトボタン押下
     */
    onLogout() {
      this.logout()
      this.$router.push('/')
    },

    /**
     * パスワード更新ボタン押下
     */
    async onChangePassword() {
      const data = await this.changePassword({
        userId: sessionStorage.userId,
        password: this.password,
        newPassword: this.newPassword,
        confirmPassword: this.confirmPassword
      });
      if (this.errMsg) {
        console.log(this.errMsg)
        swal({
          text: this.errMsg,
          type: 'error'
        })
      } else {
        console.log(data)
        swal({
          text: 'パスワードを変更しました',
          type: 'success'
        })
        this.password = ''
        this.newPassword = ''
        this.confirmPassword = ''
      }
    },

    /**
     * 画面表示時
     */
    async create_() {
      await this.getCategoryOptions()
      await this.getCategory()

      // 初期表示のカテゴリは「全て」を選択
      this.selectedCategoryId = '00'
      this.setCategoryOption_()
    },

    changeFocusByUpKey(list, currentIndex) {
      if (currentIndex === 0) return
      document.getElementById(`category-${currentIndex - 1}`).focus()
    },

    changeFocusByDownKey(list, currentIndex) {
      if (currentIndex === list.length - 1) return
      document.getElementById(`category-${currentIndex + 1}`).focus()
    }
  },

  created() {
    this.create_()
  }
}



// WEBPACK FOOTER //
// ./src/components/aftersale/setting/setting.js